import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LookupTableReducer } from '../reducers';

export const selectLookupTableFeature = createFeatureSelector<LookupTableReducer.LookupTableState>(LookupTableReducer.featureName);

export const selectLookupTable = createSelector(selectLookupTableFeature, (state: LookupTableReducer.LookupTableState) => state.item);
